import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { RoleDataPayload, RoleDataResponse } from "@/types/interface/role";

export const useRoleStore = defineStore("roleStore", () => {
  const role = ref<RoleDataResponse>();
  const roles = ref<RoleDataResponse[]>([]);

  function initRoles(data: any) {
    roles.value = data?.data;
  }

  function addNewRole(data: any) {
    role.value = data;
  }

  async function dispatchGetRoles(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.role.getRole(page, limit, queryParam);
      if (status === 200 ) {
        initRoles(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idRole = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.role.findRole(idRole);
      if (status === 200 ) {
        addNewRole(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: RoleDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.role.createRole(payload);
      if (status === 200 ) {
        addNewRole(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idRole = "", payload: RoleDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.role.updateRole(idRole, payload);
      if (status === 200 ) {
        addNewRole(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idRole = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.role.deleteRole(idRole);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    role,
    roles,
    initRoles,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetRoles,
    dispatchDelete
  };
});